import { render, staticRenderFns } from "./Loader-page.vue?vue&type=template&id=31e0ba8b&"
import script from "./Loader-page.vue?vue&type=script&lang=js&"
export * from "./Loader-page.vue?vue&type=script&lang=js&"
import style0 from "./Loader-page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports